import React from 'react';

import PropTypes from 'prop-types';

export const AlertCategory = (props) => {
    const { alertCategory } = props;

    return (
        <span>{alertCategory}</span>
    );
};

AlertCategory.propTypes = {
    alertCategory: PropTypes.string.isRequired,
};
